import { supabase } from '../../config/supabase';
import { activityLogService } from '../compliance/activityLogService';
import { ACTIVITY_LOG_ACTIONS } from '../../types/compliance';

export interface RecruitmentCatalogSettings {
  show_descriptions: boolean;
}

export const DEFAULT_RECRUITMENT_CATALOG_SETTINGS: RecruitmentCatalogSettings = {
  show_descriptions: false,
};

const SETTINGS_COLUMNS = 'show_descriptions';

export const recruitmentCatalogSettingsService = {
  async getSettings(): Promise<RecruitmentCatalogSettings> {
    const { data, error } = await supabase
      .from('recruitment_catalog_settings')
      .select(SETTINGS_COLUMNS)
      .eq('id', true)
      .maybeSingle();
    if (error) throw new Error(error.message || 'Failed to load catalog settings');
    return (data as RecruitmentCatalogSettings | null) ?? DEFAULT_RECRUITMENT_CATALOG_SETTINGS;
  },

  async updateSettings(
    patch: Partial<RecruitmentCatalogSettings>
  ): Promise<RecruitmentCatalogSettings> {
    const { data, error } = await supabase
      .from('recruitment_catalog_settings')
      .update(patch)
      .eq('id', true)
      .select(SETTINGS_COLUMNS)
      .single();
    if (error || !data) throw new Error(error?.message || 'Failed to update catalog settings');

    const result = await activityLogService.log({
      action_type: ACTIVITY_LOG_ACTIONS.ADMIN_UPDATE_RECRUITMENT_SETTINGS,
      resource_type: 'recruitment_catalog_settings',
      metadata: patch,
    });
    if (!result.success) {
      console.error('[Admin audit] Failed to record settings change:', result.error);
    }
    return data as RecruitmentCatalogSettings;
  },
};
